module.exports = __webpack_public_path__ + "img/pic03.429c6b2a.png";